const LANDING_URL_STORAGE_KEY = 'hck_ad_landing_url'
const CLICK_ID_PARAMS = ['fbclid', 'li_fat_id', 'twclid']

// Captures the current URL (last-touch, overwritten on each new ad click)
// whenever it carries a recognized ad platform's click-id query param.
// CometlyConversionJob's per-platform webhooks only fire when the url they
// receive carries a matching click id, so this is what makes that gating
// possible for the guest registration flow.
export const captureAdLandingUrl = (): void => {
  if (typeof window === 'undefined') return

  const params = new URLSearchParams(window.location.search)
  const hasClickId = CLICK_ID_PARAMS.some((param) => params.has(param))
  if (!hasClickId) return

  try {
    window.localStorage.setItem(LANDING_URL_STORAGE_KEY, window.location.href)
  } catch {
    // localStorage may be unavailable (private browsing, storage full) —
    // losing this capture just means the click id won't be attributed.
  }
}

export const getAdLandingUrl = (): string | undefined => {
  if (typeof window === 'undefined') return undefined

  try {
    return window.localStorage.getItem(LANDING_URL_STORAGE_KEY) || undefined
  } catch {
    return undefined
  }
}

// Consume-once: call after a successful registration so a later
// registration in the same browser (e.g. joining a second event) doesn't
// keep reporting the same stale click id. Without this, the captured URL
// sits in localStorage indefinitely and getAdLandingUrl() keeps returning
// it even once the visitor is no longer arriving from that ad click —
// confirmed live: two registrations several minutes apart both carried the
// twclid from the first click, with no click id present in either request's
// actual current URL. Only clear on success — a failed submit should still
// get credited to the same click on retry.
export const clearAdLandingUrl = (): void => {
  if (typeof window === 'undefined') return

  try {
    window.localStorage.removeItem(LANDING_URL_STORAGE_KEY)
  } catch {
    // Same failure mode as captureAdLandingUrl's write — nothing to clean up.
  }
}
